import React, { ReactElement, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useAppTheme } from '../hooks';
import { ConfigProvider } from 'antd';
import { useUILogic } from '../../../shared/providers/UILogicProvider/hooks';
import { colorsPalette } from '../../../../../shared/ui/styles/colors-palette';
import { COMPACT_PRODUCT_CODE } from '../../../../infrastructure/types/features/auth/auth-types';
import { generateComponentThemeMap } from '../../../../../shared/ui/ui-kit/elements/functions/themeMapper';

interface ApplicationThemeProviderProps {
  children: React.ReactNode;
}

let ApplicationThemeProvider = function ({
  children,
}: ApplicationThemeProviderProps): ReactElement {
  const { theme, changeTheme } = useAppTheme();
  const { authorizationUiModule } = useUILogic();
  const productCode = authorizationUiModule.module.productConfig?.code;

  useEffect(() => {
    changeTheme(productCode === COMPACT_PRODUCT_CODE ? 'beeline' : 'default');
  }, [productCode]);

  const components = generateComponentThemeMap(
    theme.components as Record<string, Record<string, Record<string, Color>>>,
  );

  const buttonTokens =
    theme.id === 'beeline'
      ? {
          colorPrimary: colorsPalette.beelineYellow300 as Color,
          colorPrimaryHover: colorsPalette.beelineYellow400 as Color,
          colorPrimaryActive: colorsPalette.beelineYellow300 as Color,
          colorPrimaryBorder: colorsPalette.beelineYellow300 as Color,
          primaryColor: colorsPalette.beelineBlack600 as Color,
        }
      : {
          colorPrimary: '#769E1E' as Color,
          colorPrimaryHover: '#8CBB23' as Color,
          colorPrimaryActive: '#769E1E' as Color,
          colorPrimaryBorder: '#769E1E' as Color,
        };

  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: theme.font,
          borderRadiusLG: 6,
          colorError: '#CA2521',
          colorBorder: '#DBDBDB',
        },
        components: {
          ...components,
          Button: {
            ...(components.Button ?? {}),
            ...buttonTokens,
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};

ApplicationThemeProvider = observer(ApplicationThemeProvider);
export default ApplicationThemeProvider;
